import React, { useState, useEffect } from 'react';

const AddBlog = ({ blog, onClose, onAddBlog, onUpdateBlog, authToken }) => {
  const [title, setTitle] = useState('');
  const [article, setArticle] = useState('');
  const [imageFile, setImageFile] = useState(null);
  const [preview, setPreview] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (blog) {
      setTitle(blog.title || '');
      setArticle(blog.article || '');
      setPreview(blog.image || null);
    }
  }, [blog]);

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setImageFile(file);
      setPreview(URL.createObjectURL(file));
    }
  };

  const handleSubmit = async () => {
    if (!title || !article) {
      setError('Title and article are required.');
      return;
    }

    setLoading(true);
    setError(null);

    try {
      const formData = new FormData();
      formData.append('title', title);
      formData.append('article', article);
      if (imageFile) {
        formData.append('image', imageFile);
      }

      const method = blog ? 'PUT' : 'POST';
      const url = blog
        ? `${process.env.REACT_APP_BACKEND_URL}/apis/admin/updateBlog/${blog._id}`
        : `${process.env.REACT_APP_BACKEND_URL}/apis/admin/createBlog`;

      const response = await fetch(url, {
        method,
        headers: {
          Authorization: `Bearer ${authToken}`,
        },
        body: formData,
      });

      const data = await response.json();

      if (data.success) {
        blog ? onUpdateBlog(data.data) : onAddBlog(data.data);
        onClose();
      } else {
        setError(data.message || 'Operation failed');
      }
    } catch (error) {
      console.error('Blog operation error:', error);
      setError('An error occurred. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="fixed inset-0 bg-black/50 backdrop-blur-sm flex justify-center items-center z-50 p-4">
      <div className="bg-white rounded-xl shadow-xl p-6 w-full max-w-2xl max-h-[90vh] overflow-y-auto border border-gray-200">
        <h2 className="text-xl font-bold text-gray-800 mb-4">{blog ? 'Edit Blog' : 'Add Blog'}</h2>

        {error && (
          <div className="mb-4 p-3 bg-red-50 border border-red-200 text-red-600 rounded-lg text-sm">
            {error}
          </div>
        )}

        <input
          type="text"
          placeholder="Title *"
          className="w-full px-3 py-2 border border-gray-300 rounded-lg mb-3 focus:outline-none focus:ring-2 focus:ring-gray-400 bg-white text-gray-700"
          value={title}
          onChange={(e) => setTitle(e.target.value)}
        />
        
        <textarea
          placeholder="Article *"
          className="w-full px-3 py-2 border border-gray-300 rounded-lg mb-3 h-40 focus:outline-none focus:ring-2 focus:ring-gray-400 bg-white text-gray-700"
          value={article}
          onChange={(e) => setArticle(e.target.value)}
        />

        <div className="mb-3">
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Blog Image
          </label>
          <input
            type="file"
            accept="image/*"
            className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-gray-400 bg-white text-gray-700"
            onChange={handleImageChange}
          />
        </div>

        {preview && (
          <div className="mb-4">
            <img
              src={preview}
              alt="Preview"
              className="w-full h-48 object-contain rounded border border-gray-200"
            />
          </div>
        )}

        <div className="flex justify-end gap-3 pt-4 border-t border-gray-200">
          <button
            className="px-4 py-2 border border-gray-300 rounded-lg text-gray-700 hover:bg-gray-50 transition-colors"
            onClick={onClose}
            disabled={loading}
          >
            Cancel
          </button>
          <button
            className="px-4 py-2 bg-gray-800 text-white rounded-lg hover:bg-gray-900 transition-colors disabled:opacity-50"
            onClick={handleSubmit}
            disabled={loading}
          >
            {loading ? 'Saving...' : (blog ? 'Update' : 'Add')}
          </button>
        </div>
      </div>
    </div>
  );
};

export default AddBlog;